/* eslint-disable camelcase */
import gql from 'graphql-tag';
import { ADDRESS_FIELDS, addressFormats } from '../AutoComplete/AddressFormats';

// eslint-disable-next-line import/prefer-default-export
export const getFieldOrder = (countryCode) => {
    const formatForCountry = Object.keys(addressFormats)
        .filter((k) => k !== 'default')
        .filter((k) => !!addressFormats[k].countries.find((l) => l === countryCode));
    const key = formatForCountry[0] ? formatForCountry[0] : 'default';
    const fieldOrder = addressFormats[key];
    return fieldOrder;
};

export const getFieldOrderV2 = (addressFormConfiguration, countryCode) => {
    const formatForCountry = Object.keys(addressFormats)
        .filter((k) => k !== 'default')
        .filter((k) => !!addressFormats[k].countries.find((l) => l === countryCode));
    const isDefault = !formatForCountry[0];
    const {
        ignoreRTL,
        order: defaultOrder
    } = getFieldOrder(countryCode);
    // the existing addressFormats are used if they have a non default configuration for
    // the country, otherwise we will use the order from individual field configurations
    const orderToUse = (!isDefault || Object.keys(addressFormConfiguration).length === 0)
        ? defaultOrder
        : Object.entries({
            address1: addressFormConfiguration.address1,
            address2: addressFormConfiguration.address2,
            city: addressFormConfiguration.city,
            stateProvince: addressFormConfiguration.stateProvince,
            postalCode: addressFormConfiguration.postalCode,
            country: addressFormConfiguration.countryField
        })
            .filter(([, config]) => config && config.displayStatus !== 'HIDDEN')
            .sort(([, a], [, b]) => a.order - b.order)
            .map(([fieldName]) => [fieldName]);

    // Remove the array that contains the country field
    const filteredOrder = orderToUse.filter((subArray) => !subArray.includes(ADDRESS_FIELDS.COUNTRY));

    return {
        ignoreRTL,
        order: filteredOrder
    };
};

export const FETCH_ADDRESS_FORM_CONFIGURATION = gql`
    query ($countryCode: String!, $locale: String!) {
        addressFormConfiguration(params: { countryCode: $countryCode, locale: $locale }) {
            country
            countryCodeIso2
            countryCodeIso3
            address1 {
                displayStatus
                label
                order
                hideReason
            }
            address2 {
                displayStatus
                label
                order
                hideReason
            }
            countryField {
                displayStatus
                label
                order
                hideReason
            }
            stateProvince {
                displayStatus
                label
                order
                hideReason
            }
            city {
                displayStatus
                label
                order
                hideReason
            }
            postalCode {
                displayStatus
                label
                order
                hideReason
            }
            postalCodeFormat
            postalCodeExample
            fieldOrder
        }
    }
`;

export const FETCH_ENTITY = gql`
    query ($entityType: String!, $entityId: String!, $locale: String!){
        entitiesFetch(entityType: $entityType, entityId: $entityId, locale: $locale){
            ancestorId,
            name,
            localization,
            id,
            abbrv
        }
    }
`;

export const FETCH_COUNTRY_DATA = gql`
query ($country: String!, $locale: String!){
    allEntitiesFetch(country: $country, locale: $locale){
        cities {
            ancestorId,
            name,
            localization,
            id,
            ancestorLocalization
        }
    }
}
`;
